import Vue from "vue";
import App from "./App";
import router from "./routes";
import "./assets/js/jquery.min.js";
import "./assets/css/global.less"; // 导入全局样式表
// import "./assets/font/iconfont/iconfont.css"; // 导入全局字体库
import "./assets/font/iconfont/iconfont.js"; // 导入全局字体库
import { store } from "@ice/stark-data";
import defaultConfig from "./config/index";
import axios from "./dao/axios";
import { translate } from "./utils/i18n";

// 保存前端配置
function saveFrontEndConfig(obj) {
    Object.keys(obj).forEach((key) => {
        store.set(key, obj[key]);
    });
}

// 获取前端配置
axios
    .get("/api/basic/rainbow")
    .then((res) => {
        if (res.data && res.data.code === 0) {
            saveFrontEndConfig(res.data.data);
        } else {
            console.error("获取设置失败");
            saveFrontEndConfig(defaultConfig);
        }
    })
    .catch((err) => {
        console.error("获取设置失败", err);
        saveFrontEndConfig(defaultConfig);
    })
    .finally(() => {
        Vue.prototype.$http = axios;
        Vue.prototype.$t = translate;

        Vue.config.productionTip = false;

        new Vue({
            router,
            render: (h) => h(App),
        }).$mount("#app");
    });
